const registerHostAgenciesData = [
  { value: 'AAA', label: 'AAA' },
  { value: 'A Ticket 2 Travel', label: 'A Ticket 2 Travel' },
  { value: 'AARC - Host Agency', label: 'AARC - Host Agency' },
  { value: 'Allure Travel', label: 'Allure Travel' },
  { value: 'ALTOUR', label: 'ALTOUR' },
  { value: 'Amadeus Hosted Solutions', label: 'Amadeus Hosted Solutions' },
  { value: 'American Travel Companies', label: 'American Travel Companies' },
  { value: 'Andavo Travel', label: 'Andavo Travel' },
  { value: 'Archer Travel Group', label: 'Archer Travel Group' },
  { value: 'Atlas Tour and Travel', label: 'Atlas Tour and Travel' },
  { value: 'Authorized Agents', label: 'Authorized Agents' },
  { value: 'Avenue Two Travel', label: 'Avenue Two Travel' },
  { value: 'Avoya Travel', label: 'Avoya Travel' },
  { value: 'Affluent Traveler Collection', label: 'Affluent Traveler Collection' },
  { value: 'American Express ', label: 'American Express ' },
  { value: 'Bannister Travel', label: 'Bannister Travel' },
  { value: 'Brenco Travel Headquarters', label: 'Brenco Travel Headquarters' },
  { value: 'Brownell Travel', label: 'Brownell Travel' },
  { value: 'Cadence Travel', label: 'Cadence Travel' },
  { value: 'Camelback Odyssey Travel', label: 'Camelback Odyssey Travel' },
  { value: 'Casino World Travel', label: 'Casino World Travel' },
  { value: 'CCVAdvantage', label: 'CCVAdvantage' },
  { value: 'Coastline Travel Advisors', label: 'Coastline Travel Advisors' },
  { value: 'Corporate Travel Planners', label: 'Corporate Travel Planners' },
  { value: 'Cruise & Travel Experts', label: 'Cruise & Travel Experts' },
  { value: 'Cruise Brothers', label: 'Cruise Brothers' },
  { value: 'Cruise Planners', label: 'Cruise Planners' },
  { value: 'CruiseOne', label: 'CruiseOne' },
  { value: 'Cruises Inc.', label: 'Cruises Inc.' },
  { value: 'Cruises-N-More', label: 'Cruises-N-More' },
  { value: 'CTP/Rennert Travel', label: 'CTP/Rennert Travel' },
  { value: 'CWT Vacations', label: 'CWT Vacations' },
  { value: 'Departure Lounge', label: 'Departure Lounge' },
  { value: 'Design Travel', label: 'Design Travel' },
  { value: 'Direct Travel', label: 'Direct Travel' },
  { value: 'Dugan\'s Travels', label: 'Dugan\'s Travels' },
  { value: 'Epperly Travel', label: 'Epperly Travel' },
  { value: 'Expedia CruiseShipCenters', label: 'Expedia CruiseShipCenters' },
  { value: 'Family Fun Cruises & Tours', label: 'Family Fun Cruises & Tours' },
  { value: 'FROSCH', label: 'FROSCH' },
  { value: 'Gifted Travel Agency', label: 'Gifted Travel Agency' },
  { value: 'Great Southern Travel', label: 'Great Southern Travel' },
  { value: 'Great Vacations', label: 'Great Vacations' },
  { value: 'Gulliver\'s Travels Service', label: 'Gulliver\'s Travels Service' },
  { value: 'In The Know Experiences', label: 'In The Know Experiences' },
  { value: 'Coral Sands Travel', label: 'Coral Sands Travel' },
  { value: 'Incentive Connection Travel', label: 'Incentive Connection Travel' },
  { value: 'Independent by Fight Centre', label: 'Independent by Fight Centre' },
  { value: 'Inteletravel', label: 'Inteletravel' },
  { value: 'KHM Consulting', label: 'KHM Consulting' },
  { value: 'Largay Travel', label: 'Largay Travel' },
  { value: 'Luxury Travel Network', label: 'Luxury Travel Network' },
  { value: 'M Travel', label: 'M Travel' },
  { value: 'M&J Travel Services', label: 'M&J Travel Services' },
  { value: 'Meridian Travel', label: 'Meridian Travel' },
  { value: 'Modern Travel Services', label: 'Modern Travel Services' },
  { value: 'Montecito Village Travel', label: 'Montecito Village Travel' },
  { value: 'Montrose Travel', label: 'Montrose Travel' },
  { value: 'NEST PLUS', label: 'NEST PLUS' },
  { value: 'Nexion', label: 'Nexion' },
  { value: 'Oasis/Palm Coast Travel', label: 'Oasis/Palm Coast Travel' },
  { value: 'Outsideagents.com', label: 'Outsideagents.com' },
  { value: 'Ovation Travel Group', label: 'Ovation Travel Group' },
  { value: 'Preferred Host Agency', label: 'Preferred Host Agency' },
  { value: 'Protravel International', label: 'Protravel International' },
  { value: 'Robinson Travel Agency', label: 'Robinson Travel Agency' },
  { value: 'SmartFlyer', label: 'SmartFlyer' },
  { value: 'TBH Travel', label: 'TBH Travel' },
  { value: 'Terra Mar Travel', label: 'Terra Mar Travel' },
  { value: 'The Travel Agent', label: 'The Travel Agent' },
  { value: 'The Travel Agent Next Door', label: 'The Travel Agent Next Door' },
  { value: 'The Travel Center - Corporate Travel', label: 'The Travel Center - Corporate Travel' },
  { value: 'The Travel Society', label: 'The Travel Society' },
  { value: 'Travel and Transport', label: 'Travel and Transport' },
  { value: 'Travel Edge', label: 'Travel Edge' },
  { value: 'Travel Experts', label: 'Travel Experts' },
  { value: 'Travel Planners International', label: ' Travel Planners International' },
  { value: 'Travel Professionals International / IAS', label: 'Travel Professionals International / IAS' },
  { value: 'Travel Quest', label: 'Travel Quest' },
  { value: 'TripGuy Travel', label: 'TripGuy Travel' },
  { value: 'Tzell - Your Travel Center', label: 'Tzell - Your Travel Center' },
  { value: 'UNIGLOBE Travel Center', label: 'UNIGLOBE Travel Center' },
  { value: 'Vacation Time Travel', label: 'Vacation Time Travel' },
  { value: 'VacationCentral.net', label: 'VacationCentral.net' },
  { value: 'Valerie Wilson Travel', label: 'Valerie Wilson Travel' },
  { value: 'World Travel  ', label: 'World Travel  ' },
  { value: 'World Travel Management', label: 'World Travel Management' },
  { value: 'World Travel Services', label: 'World Travel Services' },
  { value: 'Xstream', label: 'Xstream' },
  { value: 'YTB Travel Network', label: 'YTB Travel Network' },
  { value: 'None', label: 'NONE' },
  { value: 'Other', label: 'Other' },
];

export default registerHostAgenciesData;
